import Carousel from 'react-bootstrap/Carousel'
import { useNavigate, useParams } from 'react-router-dom'
import AddBulletinIcon from 'assets/images/bulletin/Subtract.svg'
interface ICustomCarouselProps {
    bulletins: IBulletiens[]
    isFuckingManager: () => boolean
}
export default function CustomCarousel({
    bulletins,
    isFuckingManager,
}: ICustomCarouselProps) {
    const navigate = useNavigate()
    const { id } = useParams()
    return (
        <Carousel
            indicators={false}
            controls={false}
            className="overflow-hidden rounded-[16px] bg-[#F2F2F2]"
            onClick={() =>
                navigate('/fund/bulletin', {
                    state: {
                        bulletins,
                        isManager: isFuckingManager(),
                        moneyPool: id,
                    },
                })
            }
        >
            {isFuckingManager() && (
                <Carousel.Item>
                    <div className="flex min-h-[112px] flex-col items-center justify-center px-4 py-4 text-center">
                        <img
                            src={AddBulletinIcon}
                            alt="add"
                            className="mb-3 w-12 h-12 object-contain"
                        />
                        <p className="text-sm text-black">
                            اعلان برای اعضای صندوق ثبت کنید
                        </p>
                    </div>
                </Carousel.Item>
            )}
            {bulletins.map((item) => (
                <Carousel.Item key={item.id}>
                    <div className="flex min-h-[112px] items-start gap-2 px-4 py-4">
                        <img
                            src={item.sticker.image}
                            className="w-20 h-20 shrink-0 object-contain"
                            alt=""
                            onError={(e) => {
                                e.currentTarget.style.display = 'none'
                            }}
                        />
                        <p className="flex-1 text-right text-sm text-black line-clamp-3">
                            {item.text}
                        </p>
                    </div>
                </Carousel.Item>
            ))}
        </Carousel>
    )
}
